import FAROConfig from "../components/services/faro-config.service";

export const faroConfig = async () => {
  const faroConfig = await FAROConfig.getInstance().getConfig();
  return {
    faro: {
      faro_enabled: faroConfig?.faro_enabled,
      faro_api_key: faroConfig?.faro_api_key,
      faro_collector_url: faroConfig?.faro_collector_url,
      faro_app_name: faroConfig?.faro_app_name,
      faro_app_version: faroConfig?.faro_app_version,
      faro_app_env: faroConfig?.faro_app_env,
      faro_cors_url: faroConfig?.faro_cors_url,
    },
  };
};
